// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"11":"0f0cf19a","618":"355b9c89"}[chunkId] + ".js";
};